
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Prop, Vue } from 'vue-property-decorator';
import FormInput from '@/UI/components/common/form/FormInput.vue';
import { Form } from '@/form/form';
import { Validation } from 'vuelidate';

@Component({
    components: { FormInput },
})
export default class FormGroup extends Vue {
    @Prop({ required: true }) readonly field!: string;
    @Prop({ required: true }) readonly form!: Form;
    @Prop({ type: Boolean, default: false }) readonly showCustomError!: boolean;
    @Prop() readonly label!: string;
    @Prop() readonly required!: boolean;
    @Prop({default: ''}) classes!: string;
    @Prop({default: false}) readonly isPhone!: boolean;
    anyError = false;
    get validator(): Validation {
        this.anyError = this.form.$v[this.field] && this.form.$v[this.field].$anyError ? this.form.$v[this.field].$anyError : false;
        return this.form.$v[this.field];
    }

    get serverErrors(): string[] {
        return this.form.getErrors(this.field);
    }

    attributes(attrs: Record<string, any>): any {
        attrs.name = this.field;
        attrs.autocomplete = 'off';
        attrs.change = (): void => {
            if(this.form.$v[this.field]){
                this.form.$v[this.field].$touch();
            }
            this.form.clearErrors(this.field);
        };

        attrs.change2= (): void => {
            if(this.form.$v[this.field]){
                this.form.$v[this.field].$touch();
            }
            this.form.clearErrors(this.field);
        };

        return attrs;
    }
}
